/**
 * 订单表单弹窗「其他信息」区块：备注说明文本域
 */
import { Controller, type Control } from 'react-hook-form';
import type { OrderFormData } from '../../OrderFormSchema';
import { SectionHeader } from '../SectionHeader';
import { inp, lbl } from '../utils';

interface NotesSectionProps {
  control: Control<OrderFormData>;
}

export function NotesSection({ control }: NotesSectionProps) {
  return (
    /* ⑦ 其他信息 */
    <div>
      <SectionHeader icon="ri-file-text-line" title="其他信息" color="bg-gray-50 text-gray-500" />
      <div>
        <label className={lbl}>备注说明</label>
        <Controller
          name="orderSpecialInstructions"
          control={control}
          render={({ field }) => (
            <textarea
              {...field}
              placeholder="特殊要求、注意事项等"
              rows={3}
              className={inp()}
            />
          )}
        />
      </div>
    </div>
  );
}